import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface FirmwareGroupUnassignState {
  isLoading: boolean
  error: string | undefined
  httpStatus: number | undefined
}

export const initialState: FirmwareGroupUnassignState = {
  isLoading: false,
  error: undefined,
  httpStatus: undefined
}

const firmwareGroupUnassignSlice = createSlice({
  name: 'firmware-group-Unassign',
  initialState,
  reducers: {
    firmwareGroupUnassignLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        httpStatus: 0
      }
    },
    firmwareGroupUnassignUpdateAction: (
      state,
      action: PayloadAction<number>
    ) => {
      return {
        isLoading: false,
        error: undefined,
        httpStatus: action.payload
      }
    },
    firmwareGroupUnassignErrorAction: (
      state,
      action: PayloadAction<{ errorMessage: string, httpStatus: number }>
    ) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  firmwareGroupUnassignLoadingAction,
  firmwareGroupUnassignUpdateAction,
  firmwareGroupUnassignErrorAction
} = firmwareGroupUnassignSlice.actions

export default firmwareGroupUnassignSlice.reducer
